import { initVueApp } from '../../lib/utils/vue3compat/init_vue_app.js?vue3';
import ClustersDeprecationAlert from './components/clusters_deprecation_alert.vue?vue3';

export default () => {
  const el = document.querySelector('.js-clusters-deprecation-alert');

  if (!el) {
    return false;
  }

  const { message } = el.dataset;

  return initVueApp({
    el,
    name: 'ClustersDeprecationAlertRoot',
    provide: {
      message,
    },
    component: ClustersDeprecationAlert,
  });
};
